import { YStack } from '@/components/ui/layout/layout';
import { Text } from '@/components/ui/typography';

export const JournalPending = () => {
  return (
    <YStack className="w-full max-w-3xl h-full justify-center items-center text-center gap-8 overflow-hidden mx-auto animate-in fade-in duration-500">
      <YStack className="gap-1 items-center">
        <Text size="2xl" fontFamily="serif" className="text-foreground">
          Capturing your daily activity
        </Text>
        <Text size="sm" variant="muted" className="max-w-lg leading-relaxed">
          Journal entries will appear here as you use your Mac throughout the
          day
        </Text>
      </YStack>

      <YStack className="w-full bg-surface rounded-xl p-6 text-left relative overflow-hidden border border-border gap-4">
        <Text size="sm" variant="muted">
          Here's what your journal will look like
        </Text>
        <YStack className="gap-3">
          <Text size="lg" fontFamily="serif" className="text-foreground">
            December 15th
          </Text>
          <Text size="sm" variant="muted" className="leading-relaxed">
            Started the day with a team standup and reviewed the quarterly
            goals. Spent 2 hours on client presentation prep for the Johnson
            account. Had a productive 1-on-1 with Sarah about the new feature
            roadmap. Dedicated focused time to debugging the authentication flow
            issue. Ended with reviewing tomorrow's agenda and updating project
            timelines.
          </Text>
        </YStack>
      </YStack>
    </YStack>
  );
};
